/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/StarClubChallengeMenu',[
		'lodash',
		'pixi',
		'absolute',
		'absolute/screenmetrics',
		'gameconfig',
		'MenuUI/Menu',
		'MenuUI/SideBar',
		'MenuUI/StarClubChallengeTile',
		'Solitaire/MvvmStructure/Service/SolitaireStarClubService',
		'MenuUI/ControlFocusManager',
		'Managers/ScaleManager',
		'Managers/ScrollManager'
	],
	function (_, PIXI, Absolute, ScreenMetrics, GameConfig, Menu, SideBar, StarClubChallengeTile,
	          SolitaireStarClubService, ControlFocusManager, ScaleManager, ScrollManager) {
		"use strict";

		var StarClubChallengeMenu = function (ui, game) {
			this.initStarClubChallengeMenu(ui, game);
		};

		StarClubChallengeMenu.constructor = StarClubChallengeMenu;
		StarClubChallengeMenu.prototype = Object.create(Absolute.Screen.prototype);

		StarClubChallengeMenu.prototype.initStarClubChallengeMenu = function (ui, game) {
			Absolute.Screen.call(this);
			this.ui = ui;
			this.game = game;

			var background = PIXI.Sprite.fromFrame('win10_MS_bg.png');
			this.background.addChild(background);

			this.currentWidth = Absolute.Coords.x(1791);

			this.container = new PIXI.DisplayObjectContainer();

			this.controlFocusManager = new ControlFocusManager();

			ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
		};

		StarClubChallengeMenu.prototype.initSidebar = function () {
			this.sidebar = new SideBar({
				availableHeight: 200, partialHeight: 100,
				onScrollUpdate: function (p) {
				}.bind(this)
			});
			this.addChild(this.sidebar);
			this.sidebar.position.set(Absolute.Coords.x(1900), Absolute.Coords.y(67));
			this.updateSidebar();
		};

		StarClubChallengeMenu.prototype.initTouchInterface = function () {
			// Dragging and panning
			this.lastDeltaY = 0;
			this.startY = 0;
			var hitArea = new PIXI.Rectangle(0, 0, Absolute.Coords.x(1920), Absolute.Coords.y(1080));
			this.touchContainer = new PIXI.DisplayObjectContainer();
			this.touchContainer.interactive = true;
			this.touchContainer.hitArea = hitArea;
			this.touchContainer.addChild(this.scrollable);
			this.touchContainer.mousedown = this.touchContainer.touchstart = this.handleDragStart.bind(this);
			this.touchContainer.mousemove = this.touchContainer.touchmove = this.handleDrag.bind(this);
			this.touchContainer.mouseupoutside = this.touchContainer.mouseup = this.touchContainer.touchend = this.touchContainer.touchendoutside = this.handleDragEnd.bind(this);
			this.addChild(this.touchContainer);
		};

		StarClubChallengeMenu.prototype.handleDragStart = function (data) {
			this.dragging = true;
			this.lastDeltaY = 0;
			this.startY = data.getLocalPosition(this.parent).y;
			this.enableButtons(false);
		};

		StarClubChallengeMenu.prototype.handleDrag = function (data) {

			if (!this.dragging) {
				return;
			}

			var pos = data.getLocalPosition(this.parent),
				delta = pos.y - this.startY;

			this.scrollTo(this.scrollable.y + ((delta - this.lastDeltaY)));

			this.lastDeltaY = delta;
		};

		StarClubChallengeMenu.prototype.handleDragEnd = function (data) {

			if (!this.dragging) {
				return;
			}
			this.dragging = false;
		};

		StarClubChallengeMenu.prototype.enableButtons = function (enable) {

			var i, l;

			for (i = 0, l = this.scrollable.children.length; i < l; i++) {
				this.scrollable.children[i].interactive = enable;
			}

		};

		StarClubChallengeMenu.prototype.doScroll = function (e) {
			if (!this.scrollable) return;
			if (this.scrollableFakeHeight <= Absolute.Coords.y(1080)) {
				this.scrollable.y = 0;
				return;
			}
			var deltaY = 0;
			if (!e) e = window.event;
			if (e.wheelDelta) {
				deltaY = e.wheelDelta / 35;
			} else if (e.detail) {
				deltaY = -e.detail / 3;
			}
			this.scrollTo(this.scrollable.y + (deltaY * 100));
		};

		StarClubChallengeMenu.prototype.scrollTo = function (y, scroller) {
			if (!this.scrollable) return;
			if (this.scrollableFakeHeight <= Absolute.Coords.y(1080)) {
				this.scrollable.y = 0;
				return;
			}
			this.scrollable.y = y;
			if (this.scrollable.y > 0) this.scrollable.y = 0;
			var posY = this.scrollableFakeHeight - Absolute.Coords.y(1080);
			if (Math.abs(this.scrollable.y) > posY) {
				this.scrollable.y = -posY;
			}
			if (this.sidebar) this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
		};

		StarClubChallengeMenu.prototype.startScrolling = function (delta) {
			this.sidebar.updateByArrow(delta);
		};

		StarClubChallengeMenu.prototype.updateSidebar = function () {
			if (!this.sidebar || !this.scrollable) return;
			var height = this.game.menuBar.menuBarHeight;
			var screenScaleX = ScaleManager.width / Absolute.Coords.x(1920),
				screenScaleY = ScaleManager.height / Absolute.Coords.y(1080);
			this.sidebar.scale.set(1, 1);
			this.sidebar.width = this.sidebar.width / screenScaleX;
			this.sidebar.height = this.sidebar.height / screenScaleY;
			this.sidebar.y = height / screenScaleY;
			this.sidebar.x = Absolute.Coords.x(1900) - (this.sidebar.width - (this.sidebar.width * screenScaleX));
			var availableHeight, partialHeight, posY;
			availableHeight = this.scrollableFakeHeight;
			partialHeight = Absolute.Coords.x(1080);
			posY = availableHeight - Absolute.Coords.y(1080);
			this.sidebar.resetDimensions(availableHeight, partialHeight, function (p) {
				var y = -Math.abs(posY) * p / 100;
				this.scrollable.y = y;
				if (this.scrollable.y > 0) this.scrollable.y = 0;
				if (Math.abs(this.scrollable.y) > posY) {
					this.scrollable.y = -posY;
				}
			}.bind(this), (ScaleManager.height - height));
			this.sidebar.visible = (partialHeight < availableHeight);
			this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
		};

		StarClubChallengeMenu.prototype.initTouchContainer = function () {

		};

		StarClubChallengeMenu.prototype.loadChallenges = function (challengePack) {

			var challengePackTiles = [];
			this.controlsGroupMap = {};

			while (this.container.children.length > 0) {
				this.container.removeChildAt(0);
			}

			this.controlsGroupMap[challengePack.Name] = this.controlsGroupMap[challengePack.Name] || [];

			_.forEach(challengePack.Challenges, function (challenge) {

				var tileData = this.getTileConfig(challenge.config.Data.GameMode);
				tileData.dropShadow = true;

				tileData.action = this.onChallengeSelected.bind(this);

				var challengeTile = new StarClubChallengeTile(tileData, challenge, this);
				challengePackTiles.push(challengeTile);
				this.controlsGroupMap[challengePack.Name].push(challengeTile);
			}, this);
			this.label = Absolute.StringManager(challengePack.Name);
			var menuConfig = _.extend({
				'tiles': challengePackTiles,
				'keepOneLine': true
			}, ScaleManager.scaleParams['MenuConfigs']['SCChallengeMenu']);
			this.challengePackMenu = new Menu(_.extend(menuConfig, ScaleManager.scaleParams['SCGamePacks']));
			this.container.addChild(this.challengePackMenu);

			this.scrollable = new PIXI.DisplayObjectContainer();

			this.scrollable.addChild(this.container);
			this.addChild(this.scrollable);
			this.scrollable.width = this.currentWidth;

			this.initTouchInterface();
			this.handleResize();
		};

		StarClubChallengeMenu.prototype.handleResize = function () {
			if (!this.scrollable) return;
			this.scrollTo(this.scrollable.y);
			this.container.y = (this.game.menuBar.menuButton.y + this.game.menuBar.menuButton.height)
				* (this.container.width * this.container.children[0].pageGenerator.cardScale / ScaleManager.width) * (ScaleManager.height / Absolute.Coords.y(985));
			this.updatePagesPositions();
			this.scrollable.height = (this.currentWidth / this.container.width) * (Absolute.Coords.y(985) / ScaleManager.height)
				* (ScaleManager.width / Absolute.Coords.x(1840)) * this.currentHeight;
			this.scrollable.width = this.currentWidth;
			this.scrollableFakeHeight = this.scrollable.height + Absolute.Coords.y(200);
			if ((this.scrollable.y < 0) && ((this.scrollableFakeHeight + this.scrollable.y) < Absolute.Coords.y(1080))) {
				this.scrollable.y = Absolute.Coords.y(1080) - this.scrollableFakeHeight;
			}
            this.background.scale.set(
				1 / Math.min(ScaleManager.scaleFactorX, 1), 1 / Math.min(1, ScaleManager.scaleFactorY)
			);
			this.updateSidebar();
		};

		StarClubChallengeMenu.prototype.updatePagesPositions = function () {
			var prevChild, scale = Math.max(this.container.width / this.currentWidth, 0.7),
				xPos = Absolute.Coords.x(80) * scale, yGap = Absolute.Coords.y(70) * scale,
				startY = Absolute.Coords.y(60) * scale;
			this.currentHeight = Absolute.Coords.y(50);
			this.container.children.forEach(function (c) {
				c.x = xPos;
				c.y = prevChild ? prevChild.y + prevChild.height + yGap : startY;
				this.currentHeight += c.height + (prevChild ? yGap : 0);
				prevChild = c;
			}.bind(this));
		};


		StarClubChallengeMenu.prototype.onShow = function (isPortrait) {

			Absolute.Screen.prototype.onShow.call(this);

			SolitaireStarClubService.UpdateGlobalStarClubStats();

			this.addChild(this.game.menuBar);
			this.game.menuBar.onShow(true, true, true, this.label);
			this.ui.refreshBackground = true;

			this.challengePackMenu.onShow();

			this.initControls();

			if (!this.sidebar) this.initSidebar();
			this.addChild(this.sidebar);
			this.scrollTo(0);
			this.handleResize();
			ScrollManager.add(this, this.doScroll, this);
		};

		StarClubChallengeMenu.prototype.initControls = function () {
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[0], false, 'LeftButtons');
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[1], false, 'LeftButtons');
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[2], false, 'RightButtons');
			if (this.game.menuBar.fullScreenEnabled) {
				this.controlFocusManager.addControl(this.game.menuBar.controlGroup[3], false, 'RightButtons');
			}
			for (var key in this.controlsGroupMap) {
				if (this.controlsGroupMap.hasOwnProperty(key)) {
					for (var i = 0; i < this.controlsGroupMap[key].length; i++) {
						this.controlFocusManager.addControl(this.controlsGroupMap[key][i], false, 'StarClubPacks');
					}
				}
			}
		};

		StarClubChallengeMenu.prototype.onHide = function () {
			this.controlFocusManager.removeAllControls();
			this.sectionSelected = false;
			Absolute.Screen.prototype.onHide.call(this);
			this.game.menuBar.onHide(true);
			this.challengePackMenu.onHide();
			ScrollManager.remove(this);
		};

		StarClubChallengeMenu.prototype.onChallengeSelected = function (challengePack) {
			//this.ui.navStarClubCollection(collection);
		};

		StarClubChallengeMenu.prototype.onChallengeCompleted = function (challengeTile) {
			this.game.menuBar.starCountDisplay.triggerStarAnimation(challengeTile);
		};

		StarClubChallengeMenu.prototype.getTileConfig = function (mode) {
			return GameConfig.UI.starClub.challengeTiles[mode];
		};

		StarClubChallengeMenu.prototype.handleCommand = function (command, isMouseWheel) {
			if (isMouseWheel) return;
			this.selectSection(command, isMouseWheel);
			switch (command) {
				case 'Right': {
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(1);
					break;
				}
				case 'Left': {
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(-1);
					break;
				}
				case 'Up': {
					this.controlFocusManager.focusNextControl(-1);
					break;
				}
				case 'Down': {
					this.controlFocusManager.focusNextControl(1);
					break;
				}
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					break;
				case 'Unfocus':
					this.controlFocusManager.unfocusCurrentControl();
					break;
			}
		};

		StarClubChallengeMenu.prototype.selectSection = function (command, isMouseWheel) {
			if (command === 'Tab' || command === 'ShiftTab') {
				this.controlFocusManager.focusCurrentControl();
				this.sectionSelected = true;
				if (command === 'Tab') {
					if (this.page === 2) {
						this.handlePageChange(this.page, 0);
						this.page = 0;
					} else {
						this.controlFocusManager.nextFocusGroup();
					}
				} else if (command === 'ShiftTab') {
					if (this.page === 0) {
						this.handlePageChange(this.page, 2);
						this.page = 2;
					} else {
						this.controlFocusManager.prevFocusGroup();
					}
				}
				switch (this.controlFocusManager.currentFocusGroup) {
					case 'LeftButtons':
						this.page = 0;
						break;
					case 'RightButtons':
						this.page = 1;
						break;
					case 'StarClubPacks':
						this.page = 2;
						break;
				}
			}
		};

		StarClubChallengeMenu.prototype.handlePageChange = function (from, to) {
			switch (to) {
				case 0:
					this.controlFocusManager.setFocusGroup('LeftButtons');
					break;
				case 1:
					this.controlFocusManager.setFocusGroup('RightButtons');
					break;
				case 2:
					this.controlFocusManager.setFocusGroup('StarClubPacks');
					break;
			}
		};

		return StarClubChallengeMenu;

	});

